import { motion } from "framer-motion";

const features = [
  {
    title: "Hyper-personalised diet & workout plans",
    desc: "Plans built around your actual logs, habits, preferences and progress.",
  },
  {
    title: "Expense tracker",
    desc: "Understand your food spending alongside what you're eating.",
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
};

export const UpcomingFeatures = () => (
  <section id="upcoming" className="py-24 md:py-32 lg:py-40" data-testid="upcoming-features-section">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <motion.div {...fadeUp} className="flex items-center gap-3 mb-6 md:mb-8 text-[#176B4D]">
        <span className="h-[1px] w-8 bg-[#176B4D]/50" />
        <span className="text-xs md:text-sm font-semibold tracking-[0.18em] uppercase">
          Coming soon
        </span>
      </motion.div>

      <motion.h2
        {...fadeUp}
        transition={{ ...fadeUp.transition, delay: 0.08 }}
        className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight font-medium text-[#171717] max-w-[680px]"
      >
        And it keeps getting more personal.
      </motion.h2>

      <div className="mt-14 md:mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        {features.map((f, i) => (
          <motion.div
            key={f.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="rounded-2xl border border-[#171717]/10 p-7 md:p-9"
            data-testid={`upcoming-feature-${i}`}
          >
            <span className="text-xs font-mono text-[#171717]/35">0{i + 1}</span>
            <h3 className="mt-4 font-heading text-xl md:text-2xl font-medium tracking-tight text-[#171717] uppercase">
              {f.title}
            </h3>
            <p className="mt-3 text-base leading-relaxed text-[#171717]/65">{f.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
